import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {GenericHtmlPage} from "../../models/generic-html-page.model";
import {GenericHtmlPageService} from "../../providers/generic-html-page.service";

@Component({
  selector: 'app-html-input',
  templateUrl: './html-input.component.html',
  styleUrls: ['./html-input.component.scss'],
})
export class HtmlInputComponent implements OnInit, OnDestroy {

  @Input() csrfToken: string;

  private htmlGroup: FormGroup;
  private hasUnsavedChanges = false;

  @Output() addedHtmlEmitter = new EventEmitter<GenericHtmlPage>();
  @Output() cancelEmitter = new EventEmitter<Boolean>();
  @Input() page: GenericHtmlPage;
  @Input() pageType: string;
  private htmlPageSub: Subscription;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private genericHtmlPageService: GenericHtmlPageService,
    private appStateService: AppStateService
  ) {
  }

  ngOnInit() {
    this.htmlGroup = this.formBuilder.group({
      html: [this.page?.html, Validators.required],
      css: [this.page?.css, Validators.required],
      script: [this.page?.script, Validators.required],
      title: [this.page?.title, Validators.required]
    },);
  }


  onSave() {
    this.appStateService.updateIsBusySubject(true);
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany w stronie?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      let htmlPage: GenericHtmlPage = this.commonUtils.formGroupValuesToObject<GenericHtmlPage>(new GenericHtmlPage(), this.htmlGroup);

      this.htmlPageSub = this.genericHtmlPageService.updatePage(this.pageType, htmlPage).subscribe(htmlPageUpdated => {
        this.appStateService.updateIsBusySubject(false);
        if (htmlPageUpdated) {
          this.commonUtils.presentInfoToast('Zmiany zostały zapisane').then(res => {
            this.addedHtmlEmitter.emit(htmlPageUpdated);
          });
        } else {
          this.commonUtils.presentAlertToast('Wystąpił bład podczas zapisywania zmian');
        }
      }, error => {
        this.appStateService.updateIsBusySubject(false);
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisywania zmian');

      });
    }, () => {
    });
  }

  onCancelAdd() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany. Na pewno chcesz zrezygnować z edycji strony?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.cancelEmitter.emit(true);
      }, () => {
      });
    } else {
      this.cancelEmitter.emit(true);
    }
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(form, fieldName, validationType);
  }

  isFormInvalid(form: FormGroup, validationType: string) {
    return this.commonUtils.isFormInvalid(form, validationType);
  }

  ngOnDestroy(): void {
    if (this.htmlPageSub) this.htmlPageSub.unsubscribe();
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
    }
  }
}
